<template>
<div class="custom-block tip">
    <p class="custom-block-title">Importante</p>
    <p>Para más información sobre los errores generales y de negocio retornados en las respuestas de los servicios, consultar la documentación 
        <a href="/apis/documentation/apireferencesV2/errorcodes/" class="">Códigos de Error</a>
    </p>
</div>
</template>
<script>
export default {
    name: 'TipErrorV2'
}
</script>